import { apiService } from "../../../services/apiService";
import { apiServiceConstants } from "../../../constants";
import { utilService } from "../../../services/utilService";
import {
  RespDoctorListModel,
  doctorListResultInterface,
  doctorListParams,
  ShiftTime,
  Group,
  TemplateAvailability,
} from "../../Shared/DoctorList/doctor-list.model";
import _ from "lodash";

const getRequestCoverageDoctorList = async (
  params: doctorListParams
): Promise<doctorListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/list-user-rc/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const doctorListResp = res as RespDoctorListModel;
      const doctorListResponse = setDoctorListModel(
        doctorListResp.result?.[0]?.data
      );
      const result: doctorListResultInterface = {
        isSuccess: true,
        doctorListResult: doctorListResponse,
        status: doctorListResp.status,
        message: doctorListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getONusersList = async (
  params: any
): Promise<any> => {
  const respApiResult:any = await apiService
    .apiCall(
      `open-network/on-users?reg_code=${params?.reg_code}`,
      {
      search: params?.search,
      site_id:params?.site_id ,
      specialty_id: params?.specialty_id,
      page:params?.page
      },
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getONSpecialities = async (
  params: any
): Promise<any> => {
  const respApiResult:any = await apiService
    .apiCall(
      `open-network/specialty?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getONSites = async (
  params: any
): Promise<any> => {
  const respApiResult:any = await apiService
    .apiCall(
      `hospital/client/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getOnCallLookUpDoctorList = async (
  params: doctorListParams,selectedNetwork?:string
): Promise<doctorListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/oncall-lookup/?reg_code=${utilService.getNetwork()}&n2n_network=${selectedNetwork}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const doctorListResp = res as RespDoctorListModel;
      // const doctorListResponse = setDoctorListModel(
      //   doctorListResp.result?.[0]?.data
      // );
      const result: any = {
        isSuccess: true,
        doctorListResult: doctorListResp.result?.[0]?.data,
        status: doctorListResp.status,
        message: doctorListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getNotOnCallLookUpDoctorList = async (
  params: doctorListParams,selectedNetwork?:string
): Promise<doctorListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/available-not-oncall-lookup/?reg_code=${utilService.getNetwork()}&n2n_network=${selectedNetwork}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const doctorListResp = res as RespDoctorListModel;
      const doctorListResponse = setDoctorListModel(
        doctorListResp.result?.[0]?.data
      );
      const result: any = {
        isSuccess: true,
        doctorListResult: doctorListResponse,
        status: doctorListResp.status,
        message: doctorListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getSwapCallDoctorList = async (
  params: doctorListParams
): Promise<doctorListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/list-user-sc-v3/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const doctorListResp = res as RespDoctorListModel;
      const doctorListModel = setDoctorListModel(doctorListResp.result?.[0]?.data);
      const result: doctorListResultInterface = {
        isSuccess: true,
        doctorListResult: doctorListModel,
        status: doctorListResp.status,
        message: doctorListResp.message,
        count: doctorListResp.result?.[0]?.count,
        next: doctorListResp.result?.[0]?.next,
        previous: doctorListResp.result?.[0]?.previous,
      };
      return result;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getUnassignedUserList = async (
  params: any
): Promise<doctorListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/unassigned-user-list-v2/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const doctorListResp = res as RespDoctorListModel;
      const doctorListResponse = setDoctorListModel(doctorListResp.result);
      const result: doctorListResultInterface = {
        isSuccess: true,
        doctorListResult: doctorListResponse,
        status: doctorListResp.status,
        message: doctorListResp.message,
      };

      return result;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getOnBehalfUserList = async (
  params: any
): Promise<doctorListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/schedule-name-list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const doctorListResp = res as RespDoctorListModel;
      const doctorListResponse = setOnBehalfDoctorListModel(
        doctorListResp.result
      );
      const result: doctorListResultInterface = {
        isSuccess: true,
        doctorListResult: doctorListResponse,
        status: doctorListResp.status,
        message: doctorListResp.message,
      };

      return result;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getStatusBoardDoctorList = async (
  params: any
): Promise<doctorListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/sboard-schedules/doctor-v2/?reg_code=${utilService.getNetwork()}&bedId=${params?.bedId
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const doctorListResp = res as RespDoctorListModel;
      const doctorListResponse = setDoctorListModel(
        doctorListResp.result?.[0]?.doctor_list
      );
      const result: doctorListResultInterface = {
        isSuccess: true,
        doctorListResult: doctorListResponse,
        status: doctorListResp.status,
        message: doctorListResp.message,
      };

      return result;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setDoctorListModel = (payload: any): any => {
  let DoctorListArray = payload.map((object: any, key: any) => {
    return {
      guid: object.guid,
      firstName: object.first_name,
      lastName: object.last_name,
      displayName: object.display_name,
      profilePic: mapProfilePicData(object.profile_pic),
      color: object.color,
      shiftTime: mapShiftTimeDetails(object.shift_time),
      onGoing: object.on_going,
      offline:object.off_line ?? null,
      availableWhenNotOncall:object?.available_when_not_oncall ?? null,
      groups: object.groups,
      mobileNumber: object.mobile_number,
      scheduleNames: object.schedule_names,
      red: object.red,
      leave: object.leave,
      speciality: object.speciality,
      yellow: object.yellow,
      templateAvailability: mapTemplateAvailabilityDetails(
        object.template_availability
      ),
      isSelected:object?.isSelected ? object?.isSelected : false,
      isPermanentlySelected: object.isSelected,
      emergencyProviderId: object.emergency_provider_id,
      numberBadge: object.number_badge,
      unlinkTill: object.unlink_till,
      canEditTime: object.can_edit_team_datetime,
      teamStartDate: object.team_start_date,
      teamStartTime: object.team_start_time,
      teamExpiryDate: object.team_expiry_date,
      teamExpiryTime: object.team_expiry_time,
      isTeamAdmin: object.is_team_admin,
      addedToFavorite: object.added_to_favorite,
      teamUnlink: object.team_unlink,
      designation: object.designation,
      teamsAvailable: object.teams_available,
      profileStatusMessage: object.profile_status_message,
      statusMessageAvailable: object.status_message_available,
      id:object?.id,
      sites:object?.sites 
    };
  });
  return DoctorListArray;
};

const setOnBehalfDoctorListModel = (payload: any): any => {
  let DoctorListArray = payload.map((object: any) => {
    return {
      guid: object.guid,
      firstName: object.first_name,
      lastName: object.last_name,
      text: object.text,
    };
  });
  return DoctorListArray;
};

const mapProfilePicData = (profilePic: string) => {
  return profilePic && profilePic !== "" ? profilePic : "assets/images/defaultProfilePic.png";
};

const mapShiftTimeDetails = (shiftTimeData: Array<ShiftTime>) => {
  var shiftTimeObject: any;
  if (shiftTimeData == null) {
    return [];
  } else {
    let shiftTimeArray: Array<ShiftTime> = [];
    shiftTimeData.map((items: any) => {
      shiftTimeObject = {
        scheduleNameId: items.schedule_name_id,
        startTime: items.start_time,
        endTime: items.end_time,
        group: mapGroupDetails(items.group),
      };
      shiftTimeArray.push(shiftTimeObject);
    });
    return shiftTimeArray;
  }
};

const mapGroupDetails = (groupData: Group) => {
  var groupObject = {
    id: groupData.id,
    name: groupData.name,
    speciality: groupData.speciality,
  };

  return groupObject;
};

const mapTemplateAvailabilityDetails = (
  templateAvailabilityData: TemplateAvailability
) => {
  if (templateAvailabilityData == null) {
    return {};
  } else {
    var templateAvailabilityObject = {
      id: templateAvailabilityData.id,
      active: templateAvailabilityData.active,
      startTime: templateAvailabilityData.start_time,
      endTime: templateAvailabilityData.end_time,
    };
    return templateAvailabilityObject;
  }
};
const getSelectedUsersList = (data: any) => {
  if (!_.isArray(data)) {
    var initialArray = [];
    initialArray.push(data);
    return initialArray;
  } else {
    const userList: any = [];
    data.forEach((element: any) => {
      userList.push(element["guid"]);
    });
    return userList;
  }
};

const handleErrorResponse = () => { };

export const doctorsListService = {
  getRequestCoverageDoctorList,
  getOnCallLookUpDoctorList,
  getNotOnCallLookUpDoctorList,
  getSwapCallDoctorList,
  getUnassignedUserList,
  getOnBehalfUserList,
  setDoctorListModel,
  handleErrorResponse,
  getSelectedUsersList,
  getStatusBoardDoctorList,
  mapProfilePicData,
  getONusersList,
  getONSpecialities,
  getONSites
};


